<script lang="ts">
    import { PRODUCT_VARIANT_DEFAULT_TITLE } from "@/constants";

    export let selectedOptions: Record<string, string>;

    const isDefaultVariant =
        Object.values(selectedOptions).length === 1 &&
        selectedOptions["Title"] === PRODUCT_VARIANT_DEFAULT_TITLE;
</script>

{#if !isDefaultVariant}
    <ul class="gw-wl-page-item__options">
        {#each Object.keys(selectedOptions) as optionKey}
            <li class="gw-wl-page-item__options-item">
                <span class="gw-wl-page-item__options-item-name">
                    {optionKey}:
                </span>
                <span class="gw-wl-page-item__options-item-value">
                    {selectedOptions[optionKey]}
                </span>
            </li>
        {/each}
    </ul>
{/if}

<style lang="postcss">
    .gw-wl-page-item__options {
        margin: 0;
        padding: 0;
        list-style: none;
        display: flex;
        gap: 0.75em;
        flex-wrap: wrap;

        &-item {
            &-name {
                color: #777e90;
                font-size: 0.875em;
                font-weight: 500;
                padding: 0;
            }
            &-value {
                color: #141416;
                font-size: 0.875em;
                font-weight: 500;
                padding: 0;
            }
        }
    }
</style>
